import { useMediaQuery } from 'react-responsive';

const useIsMaxScreen = () => {
  const isMobile = useMediaQuery({ minWidth: 1440 });
  return isMobile;
};

export default useIsMaxScreen;
